import { API_BASE_URL } from '../constants/config';

/**
 * Convert a relative `/media/...` path (as returned by Django) into a
 * fully-qualified URL pointing at the backend origin. Passes absolute URLs
 * through untouched.
 */
export function getFullMediaUrl(path: string | null | undefined): string | null {
  if (!path) return null;
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  const origin = API_BASE_URL.replace(/\/api\/v1\/?$/, '');
  return `${origin}${path}`;
}
